import React, { useState, useEffect, useContext } from "react";
import { Store } from "react-notifications-component";
import classes from "./GetSupplyReport.module.css";
import axios from "axios";
import AllSupplyAnalysis from "./GetSupplyReportTabs/AllSupplyAnalysis";
import AllInvoiceAnalysis from "./GetSupplyReportTabs/AllInvoiceAnalysis";
import ItemSalesAnalysis from "./GetSupplyReportTabs/ItemSalesAnalysis";
import DatePicker, {
  DateObject,
  getAllDatesInRange,
} from "react-multi-date-picker";
// import { DateRangePicker } from "rsuite";
import {
  Row,
  Col,
  Form,
  Card,
  Button,
  Table,
  Tabs,
  Tab,
} from "react-bootstrap";
import { AutoComplete, Divider } from "rsuite";
import ProcessingModal from "./Modals/ProcessingModal";
import PermissionContext from "../../Store/permission-context";
const GetSupplyReport = () => {
  const [Dates, setDates] = useState("");
  const [AllDates, setAllDates] = useState([]);
  const [DateCategory, setDateCategory] = useState("specific");
  const [DatesSelected, setDatesSelected] = useState([]);
  const [SingleDate, setSingleDate] = useState("");
  const [DatesToSend, setDatesToSend] = useState({});
  const [DisplayTab, setDisplayTab] = useState(false);
  const [disableButton, setdisableButton] = useState(false);
  const [causeChange, setcauseChange] = useState(false);
  const [sentAllSupply, setsentAllSupply] = useState([]);
  const [sentAllInvoices, setsentAllInvoices] = useState([]);

  const [TableToShow, setTableToShow] = useState(-1);
  const [ShowProcessing, setShowProcessing] = useState(false);
  const PCtx = useContext(PermissionContext);

  const dateCategoryChange = (e) => {
    if (e.target.checked) {
      setDateCategory(e.target.value);
      setDates("");
    }
  };

  const DeleteItem = async (Rdetails) => {
    setTableToShow(Rdetails.ind);
    let MStatus = await PCtx.connectAxios("deletethisreceipt.php", Rdetails);

    if (!MStatus.includes("Failure")) {
      GetTheReport();
      PCtx.displayAlert(
        "SUCCESS",
        "Receipt Number " +
          Rdetails.Rid +
          " of " +
          Rdetails.Amt +
          " has been successfully deleted. If the items are returned, kindly enter the returned items under the Supply Menu in order to balance the stock",
        "success",
        7000
      );
    }
  };

  const GetTheReport = async () => {
    if (DatesSelected.length <= 31) {
      setShowProcessing(true);
      setDisplayTab(false);

      let RecordSupply = await PCtx.connectAxios(
        "getallsupplyrecords.php",
        DatesToSend
      );
      // console.log(RecordSupply);
      setsentAllSupply(RecordSupply);

      let InvoiceUploads = await PCtx.connectAxios(
        "getallinvoicerecords.php",
        DatesToSend
      );
      setsentAllInvoices(InvoiceUploads);
      setcauseChange(!causeChange);
      setDisplayTab(true);
      setShowProcessing(false);
    } else {
      PCtx.displayAlert(
        "TOO MANY DAYS",
        "Oops! You cannot select more than 31 days. Please pick lower dates range.",
        "danger",
        3000
      );
    }
  };

  //This is to make sure that the dates are selected before Generate Button is clicked.
  useEffect(() => {
    let dts = DateCategory === "specific" ? SingleDate : DatesSelected;
    let datats = { dates: dts, type: DateCategory, Category: "Group" };
    setDatesToSend(datats);
    Dates === "" ? setdisableButton(true) : setdisableButton(false);
  }, [DatesSelected, SingleDate, causeChange]);

  useEffect(() => {
    // if (AllDates.length > 0) {
    if (Dates != "") {
      let AD = AllDates.map((d) => d.toString());
      let SD = Dates.toString();
      setDatesSelected(AD);
      setSingleDate(SD);
    }
    // }
  }, [AllDates, Dates]);
  return (
    <Row className={classes.margin4printing}>
      <Col md={12} className={classes.margin4printing}>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ height: "35px" }}>
              <Card.Body>
                <h4
                  className="text-center "
                  style={{ color: "brown", fontFamily: "Times New Roman" }}
                >
                  <Divider className="m-0">SUPPLY REPORTS</Divider>
                </h4>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <Row className={classes.hide4printing}>
          <Col md={12}>
            <Card style={{ minHeight: "60px" }}>
              <Card.Body className="m-0 p-0">
                <Row className="justify-content-around align-items-center">
                  <Col md={3} sm={12} xs={12} className="text-center">
                    <p className={classes.please}>PLEASE PICK REPORT DATE</p>
                  </Col>
                  <Col
                    md={3}
                    sm={12}
                    xs={12}
                    className="mt-1"
                    style={{ paddingLeft: "120px" }}
                  >
                    <p className="m-0 p-0 ml-5">
                      <label className={classes.labelradio}>
                        <input
                          type="radio"
                          defaultChecked={true}
                          name="datetype"
                          value="specific"
                          onChange={dateCategoryChange}
                        />
                        {" Specific Date"}
                      </label>
                    </p>
                    <p className="m-0 p-0">
                      <label className={classes.labelradio}>
                        <input
                          type="radio"
                          name="datetype"
                          value="range"
                          onChange={dateCategoryChange}
                        />
                        {" Range"}
                      </label>
                    </p>
                  </Col>
                  <Col md={3} sm={12} xs={12} className="text-center">
                    <label className={classes.labelradio}>
                      Please pick a date
                      <br />
                      <DatePicker
                        value={Dates}
                        editable={false}
                        style={{ border: "1px solid brown", height: "30px" }}
                        placeholder="Click me to open calendar!"
                        onChange={(dateObjects) => {
                          setDisplayTab(false);
                          setdisableButton(false);
                          setDates(dateObjects);
                          setAllDates(getAllDatesInRange(dateObjects));
                        }}
                        format="MMM DD, YYYY"
                        range={DateCategory === "range" ? true : false}
                        shadow={true}
                      />
                    </label>
                  </Col>
                  <Col
                    md={3}
                    sm={12}
                    xs={12}
                    className="align-self-center text-center"
                  >
                    <Button
                      variant="info"
                      onClick={GetTheReport}
                      disabled={disableButton}
                      style={{ backgroundColor: "brown", color: "white" }}
                    >
                      Generate Report
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        {DisplayTab && (
          <Row className={classes.margin4printing}>
            <Col md={12} sm={12} xs={12} className={classes.margin4printing}>
              <Tabs
                defaultActiveKey="home"
                id="uncontrolled-tab-example"
                className={`${classes.hide4printing} ${"mb-3"}`}
                style={{ border: "1px brown solid" }}
              >
                <Tab
                  eventKey="home"
                  title="All Supply Analysis"
                  className={classes.margin4printing}
                >
                  <AllSupplyAnalysis
                    Records={sentAllSupply}
                    myDates={DatesToSend}
                    TableToShow={TableToShow}
                    DeleteFunction={DeleteItem}
                    Reload={GetTheReport}
                  />
                </Tab>
                <Tab
                  eventKey="invoice"
                  title="Invoices Uploaded"
                  className={classes.margin4printing}
                >
                  <AllInvoiceAnalysis
                    Records={sentAllInvoices}
                    myDates={DatesToSend}
                  />
                </Tab>
              </Tabs>
            </Col>
          </Row>
        )}
      </Col>
      {ShowProcessing && <ProcessingModal Show={ShowProcessing} />}
    </Row>
  );
};

export default GetSupplyReport;
